import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { APP_ENVIRONMENT } from "@kalmarenergi/util/config";
import { environment } from "../environments/environment";

import {
  mockApiInterceptor,
  provideMockApiHandlers,
} from "@kalmarenergi/util/interceptors/mock-api";
import { appRoutes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([mockApiInterceptor])),
    { provide: APP_ENVIRONMENT, useValue: environment },
    ...(environment.mockApi.enabled
      ? [provideMockApiHandlers(environment.mockApi.handlers)]
      : []),
  ],
};
